import 'bootstrap/dist/css/bootstrap.min.css';
import './DataTable.css';
import Navbar from './Navbar'; 
import DataTable from './DataTable'; 

function App() {
  return (
      <div>
          <Navbar />
          <DataTable />
      </div>
  );
}

export default App;
